import { useCallback, useEffect, useState } from 'react';
import { getSpaCommunicationCapabilities } from '../APIs/SpaAPI';
import { validCapabilities } from '../utils/spaCommunications';

export default function useSpaCommunicationCapabilities(token, tenant, allowed) {
  const [state, setState] = useState(null);
  const [reload, setReload] = useState(0);
  const key = `${token}:${tenant}:${allowed}`;
  const refresh = useCallback(() => setReload((value) => value + 1), []);
  useEffect(() => {
    if (!allowed || !token || !tenant) return undefined;
    const controller = new AbortController();
    setState({ key, loading: true });
    getSpaCommunicationCapabilities(token, tenant, { signal: controller.signal }).then((data) => {
      if (!validCapabilities(data)) throw new Error('Invalid communication capabilities response');
      if (!controller.signal.aborted) setState({ key, data });
    }).catch((error) => {
      if (!controller.signal.aborted) setState({ key, error: error.message });
    });
    return () => controller.abort();
  }, [key, token, tenant, allowed, reload]);
  return { ...(allowed && state?.key === key ? state : {}), refresh };
}
